export default $messageModal => {
  const getForm = () => $messageModal.form
  const getOpenModal = () => $messageModal.openModal

  return { getForm, getOpenModal }
}
